import { RepeatByDayOptions } from 'utils/gloo-types';
import { SelectOption } from './frontendTypes';

export function generateNumberOptions(
  options: { start?: number; end?: number; interval?: number; labelPrefix?: string } = {},
) {
  const { start = 1, end = 30, interval = 1, labelPrefix } = options;
  const results: SelectOption<number>[] = [];
  for (let i = start; i <= end; i += interval) {
    results.push({ label: `${labelPrefix ? labelPrefix + i : i}`, value: i });
  }
  return results;
}

export const DayOfWeekOptions: SelectOption<RepeatByDayOptions>[] = [
  { label: 'Sunday', value: 'SU' },
  { label: 'Monday', value: 'MO' },
  { label: 'Tuesday', value: 'TU' },
  { label: 'Wednesday', value: 'WE' },
  { label: 'Thursday', value: 'TH' },
  { label: 'Friday', value: 'FR' },
  { label: 'Saturday', value: 'SA' },
];

export const RepeatFrequencyOptions = [
  { label: 'Once', value: 'once' },
  { label: 'Weekly', value: 'weekly' },
  // { label: 'Monthly', value: 'monthly' },
];

export const ReminderDayOptions: SelectOption<number | null>[] = [
  { label: 'No Reminder', value: null },
  { label: '1 Day after', value: 1 },
  { label: '2 Days after', value: 2 },
  { label: '3 Days after', value: 3 },
];

export function generateTimeOptions(
  options: { startHr?: number; endHr?: number; intervalMin?: number; tzToShow?: string } = {},
) {
  const { startHr = 8, endHr = 20, intervalMin = 30 } = options;
  const results: SelectOption<string>[] = [];
  for (let i = startHr; i <= endHr; i += 1) {
    for (let j = 0; j < 60; j += intervalMin) {
      const hours = `0${i.toString()}`.substr(-2);
      const minutes = `0${j.toString()}`.substr(-2);
      const str = `${hours}:${minutes}`;
      const viewHr = i === 12 || i === 0 ? 12 : i % 12;
      const label = `${viewHr}:${minutes} ${i > 11 ? 'PM' : 'AM'} ${options.tzToShow || ''}`;
      results.push({ label, value: str });
    }
  }
  return results;
}

export const orgTypeFilteringOptions: SelectOption<string>[] = [
  {
    value: 'church',
    label: 'Church',
  },
  {
    value: 'recovery',
    label: 'Recovery',
  },
  {
    value: 'all',
    label: 'All',
  },
];
